import { SVGProps } from 'react';
export const PrivacyBilby = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		id="Layer_2"
		data-name="Layer 2"
		viewBox="0 0 737.14 876.58"
		{...props}
	>
		<defs>
			<style>
				{
					'.cls-5{fill:#a5b8c9}.cls-6{fill:#a4b7c9}.cls-7{fill:#1e416f}.cls-8{fill:#1d406f}.cls-12{fill:#1f4371}.cls-22{fill:#86caef}.cls-25{fill:#1d3f6e}.cls-31{fill:#fcfcfc}.cls-33{fill:#1e4170}.cls-38{fill:#faa97d}.cls-40{fill:#1e4271}.cls-43{fill:#fdfdfd}'
				}
			</style>
		</defs>
		<g id="Layer_1-2" data-name="Layer 1">
			<path
				d="M229.98 645.58c.43-10.39 1.66-21.93 3.29-32.21 1.81-11.39 5.45-22.45 7.2-33.8l-22.49 6.02c4.66 31.91 4.96 43.58-28.62 48.86-33.12 5.21-68.26 7.46-101.75 11.25-13.78 1.56-38.51 8.17-50.64 2.39-14.4-6.86-11.3-34.42-13.18-47.82-5.45-4.99-11.43-6.48-15.65-13.36-8.32-13.59-12.19-40.48-2.16-53.83 1.75-2.33 7.91-6.28 7.95-7.91-2.33-12.53-2.47-25.36-4.08-37.97-1.71-13.37-6.24-29.16-6.85-42.14-.78-16.37 6.34-22.66 21.62-25.35 35.94-6.33 78.44-11.53 114.87-15.13 10.82-1.07 37.99-4.97 46.44.54 4.91 3.2 9.1 10.82 10.59 16.41l12.46 92.05c13.54-5.77 26.44-12.78 38.91-20.58 4.71-2.95 24.83-15.7 26.97-19.03 4.24-6.57 7.5-34.42 1.16-40.93-27.7-12.44-54.04-24.05-79.96-40.04-8.9-5.49-10.91-8.39-21.13-11.87-11.76-4-23.82-10.21-28.01-22.99-9.03-27.51 24.07-41.65 45.38-30.38 4.01 2.12 7.7 6.94 11.45 8.55 11.72 5.05 42.28 7.03 52.72-.74 14.05-10.44 19.59-50.68 25.49-67.51 3.09-8.83 8.02-16.63 11.99-25.02-32.76-43.47-51.89-92.67-49.02-148.01 1.26-24.25 10.04-67.57 22.85-88.15 9.12-14.65 16.57-2.08 24.17 7.22 20.26 24.81 37.52 59.32 45.74 90.26 7.72 29.03 9.92 59.18 9.33 89.17 3.25-1 19.05 6.77 19.96 6.03-1.92-4.24-9.75-18.33-8.85-22.28 2.19-9.57 22.14 1.11 26.77 3.87 11.12 6.63 20.1 15.82 28.59 25.41 1.34 1.51 3.87 6.07 4.79 6.71 1.59 1.1 6.46 1.52 8.96 2.54 4.16 1.7 10.89 5.73 14.27 6.74 1.87.55 1.32-.31 1.47-1.46 2.18-16.59.77-36.11 3.13-53.89 7.69-58.12 37.97-119.04 82.34-157.66 12.6-10.96 17.51-15.26 25.7 2.35 5.51 11.84 9.73 28.74 11.83 41.67 2.87 28.82 3.7 58.28-1 87-11.82 55.07-47.58 81.38-65 128-7.71 16.77-8.69 41.89-8.95 62.47 1.33 34.91-.55 70.43-2.63 105.01l.58 1.53c1.92.23 29.52-11.89 33.68-13.82 11.75-5.45 27.08-15.75 38.34-19.66 2.85-.99 5.32-2 8.48-1.57 41.43 19.81 80.54 38.21 125.5 49.05 11.11 2.05 14.5 3.23 15.66 15.86l.34 24.14c-.73 22.22-3.91 44.46-7.08 66.42 18.71 7.28 17.85 29.09 13.59 45.59-4.77 18.46-18.14 31.77-38.41 27.07-17.63 36.26-53.68 62.29-88.43 81.09-5.79 3.13-18.15 10.29-24.15 9.85-7.31-.54-34.52-17.19-42.04-22-14.49-9.28-28.28-19.92-40.47-32.02 5.64 76.64 116.66 136.8 175.97 76.5-24.09-24.79-10.24-58.43 15.49-75.53 8.79-5.84 19.13-9.24 27.84-15.16 7.05-4.79 17.52-21.32 22.15-8.78 3.83 10.38 3.13 25.69-.47 35.96 7.77-1.59 8.75-.22 10.54 6.97 7.24 29.12-10.19 67.25-43 69.07-4.16.23-14.89-2.4-16.54-1.58-1.35.67-4.85 6.78-6.49 8.56-52.51 56.92-131.44 38.25-181.5-11.01l3 69c29.38-10.81 73.87.63 90.19 28.31 12.39 21.01-4.17 23.93-21.19 25.69-19.21.82-38.77.75-58 0-7.72-.49-15.68-1.24-23.38-2.12-2.91-.33-7.07-.69-9.62-1.88-11.2-.79-21.92-3.37-32.16-7.74l-.74-4.64c-.36-11.23-.84-25.35-4.1-32.62-8.08-37.5-33.93-83.42-76.52-86.98-37.15-3.11-49.95 21.48-55.19 53.78-.86 5.3-.76 11.16-2.29 16.21-.55 10.17-.71 20.89-.46 32.17l.46-1.17 2.1 15.51c-.48 5.34-13.95 7.22-18.89 8.19-20.7 4.08-46.02 5.7-67.21 6.29-14.99-.27-29.99-.61-45-1-30.39-4.81-13.45-28.06 2.09-39.41 19.99-14.61 46.03-19.62 69.91-12.59-2.35-22.31-5.11-44.64-6.99-67-2.12-34.66-4.05-70.23-4-105Z"
				className="cls-12"
			/>
			<path
				d="M499.98 268.58c-11.85 31.72-7.8 83.13-8 118l-1 10c-.02 4.53-1 9.99-1 13.5v17c0 2.21-2.05 7.23-1 10.5-1.59-.19-1.12-7.73-1.04-9.54.72-15.9 2.64-32 3.08-47.92 1.02-36.73-4.66-74.59 7.23-109.78.22-.67.77-4.27 1.73-1.76Z"
				style={{
					fill: '#192758',
				}}
			/>
			<path
				d="M233.98 750.58c-2.91-34.45-5.44-70.41-4-105l4 105Z"
				style={{
					fill: '#08124a',
				}}
			/>
			<path
				d="M564.98 140.58c-1.92-.99-.76-3.48-.53-5.01 4.35-29.33 3.6-47.43.64-76.62-.17-1.64-.83-4.33.89-5.37 4.75 29.36 5.26 57.83-1 87Z"
				style={{
					fill: '#1e3063',
				}}
			/>
			<path
				d="m431.98 826.58 1.05-.56c2.79 12.36 3.84 24.93 4.43 37.58 2.14 3.56 29.17 6.95 34.51 6.99.27 1.67-1.89.95-3 .99-5.61.21-29.16-3.21-32.47-7.03-2.89-3.34-1.06-13.64-1.54-18.46-.58-5.84-1.76-13.79-2.99-19.51Z"
				style={{
					fill: '#132458',
				}}
			/>
			<path
				d="M559.98 875.58c-3.07.32-9.98 1-12.5 1h-32c-3.17 0-9.6-.75-13.5-1h58Z"
				style={{
					fill: '#03164f',
				}}
			/>
			<path
				d="M694.98 451.58c5.62 1.35 12.19.09 15.07 7.43 2.01 5.12 1.15 25.78.93 32.57-4.23-14.53 7.18-39.14-16.5-39.01l.5-.99Z"
				style={{
					fill: '#061046',
				}}
			/>
			<path
				d="M213.98 870.58c-13.65.38-31.8 1.09-45-1 3.94-2.68 9.31-.12 13.46.04 8.64.35 17.4-.17 26.06-.06 1.69.02 4.45-.64 5.49 1.02Z"
				style={{
					fill: '#050d45',
				}}
			/>
			<path
				d="M297.98 809.58c.14 10.3.11 20.7 0 31 0 .59.78 6.86-1 5.5v-40.99c1.69-1.64 1 4 1 4.5Z"
				style={{
					fill: '#010c46',
				}}
			/>
			<path d="M490.98 396.58c.01-3.14-.83-7.7 1-10-.02 3.14.83 7.7-1 10Z" className="cls-12" />
			<path
				d="M432.98 452.58c-5.69 1.33-8.23 3.9-9 10 .5 12.66.5 25.33 0 38 .29 10.31 2.04 20.8 2 31 .96 17.81-.04 35.69-3 53.67-.57 48.38-4.89 99.24-54.33 122.04-63.45 29.26-137.75-20.57-128.67-91.7-.07-.99.11-2.02 0-3 3.82-29.24 11.82-57.58 24-85 5.9-17.15 13.56-33 18-51 2.75-12.5 3.95-25.14 3.6-37.92-.86-8.33-1.41-11.61-9.6-14.08-27.78-12.62-57.44-22.47-82-41l2.12-1.35c61.43 15.02 125.37 11.48 184-9.82 9.5-2.5 19.12-4.83 28.91-5.71 57.94-5.21 44.72 47.49 26.88 83.83l-2.91 2.05Z"
				className="cls-31"
			/>
			<path
				d="M193.98 383.58c-.9-.37-3.91-1.85-3.99-2.99 15.23-4.69 24.19-20.7 18-36.01 24.23 4.41 49.91 9.06 62.87-16.63 11.17-22.14 12.55-48.65 23.6-71.4 2.24-4.62 7.94-9.63 5.99-14.93-43.99-57.91-58.81-123.13-40.19-194.26 1.75-6.67 11.23-37.15 16.22-39.78 24.45 28.41 44.31 61.29 54.21 97.78 7.7 28.36 9.51 56.94 10.29 86.22-25.74.43-8.11 21.37 4.33 28.16 1.45.79 7.07 4.47 7.67 1.31.88-4.66-16.77-13.85-18.99-21-.58-1.87.35-1.32 1.47-1.48 6.95-.98 19.89 3.66 26.49 6.53 2.69 1.17 14.27 8.38 15.05 8.02 6.16-2.85-5.27-17.85-7.19-21.88-1.05-2.21-3.24-7.13-3.72-9.29-.5-2.27 1.65-1.46 3.16-1.15 8.93 1.83 24.83 14.1 31.28 20.73 3.27 3.36 11.04 15.7 12.9 17.1 2.37 1.78 18.2 5.2 23.89 8.11 4.43 2.27 10.21 10.21 11.61 1.26 1.51-9.67.28-23.71 1.07-33.93 5.61-72.08 30.92-133.16 85.98-181.02 1.09-.95 7.17-6.09 8-5.48 23.89 52.35 25.01 118.88.88 171.35-18.62 40.48-55.15 72.26-58.86 119.64.99 23.98.7 48.02 0 72l-4.13 69.87c-11.03 3.04-21.89 6.83-33.05 9.45-5.35 1.26-10.6 1.46-15.82 2.68 5.73-15.66 14.64-31.52 15.98-48.52 5.07-64.19-80.31-23.79-112.8-16.8-40.98 8.83-84.26 7.69-125.37 0-5.19-.97-12.08-1.75-16.81-3.69Z"
				className="cls-6"
			/>
			<path
				d="M697.97 556.58c-15.46-5.16-35.6 7.06-24.99 23.99-11.84 2.54-14.81 16-6 23.99-11.83 7.18-4.42 20.93 5.98 25.52-20.01 33.49-52.26 57.63-86.31 75.67-4.35 2.3-16.67 9.5-20.68 8.4s-14.35-7.09-18.66-9.4c-29-15.52-60.07-39.05-78.56-66.44-34.14-50.61-39.35-116.47-37.58-176.04 1.2-3.97 17.17-4.84 22.02-5.98 39.39-9.3 76.32-27.37 111.78-46.26l5.85.22c41.21 20.36 83.34 41.83 129.45 48.55 6.69 2.03 3.75 18.16 3.68 23.24-.33 24.98-1.67 49.91-5.97 74.54Z"
				className="cls-22"
			/>
			<path
				d="M209.98 572.58c1.36 8.99 2.55 18.15 3.56 27.46.95 9.56.96 24.09-11.56 24.54-4.7 1.59-8.8 2.09-13.64 2.86-30.58 4.84-62.84 6.77-93.73 10.27-12.35 1.4-41.75 8.02-52.07 4.82-14.65-4.54-8.75-31.03-12.55-42.94 9.46.74 23.63-2.22 27.48-12.02 3.92-9.98-4.74-14.58-4.42-16.36.38-2.11 6-3.93 4.89-12.04-1.21-8.94-12.95-10.96-12.94-12.09 15.87-18.74-7.78-31.17-25.01-23.5-.75-11.76-1.61-23.68-3.13-35.37-1.75-13.47-5.98-29.19-6.74-42.25-.83-14.23 3.43-17.1 16.5-19.25 40.57-6.67 92.31-14.85 132.88-17.12 4.98-.28 13.26-.6 18.01-.03 11.58 1.37 12.73 16.63 14.31 25.69l18.17 137.33Z"
				style={{
					fill: '#fcfdfd',
				}}
			/>
			<path
				d="m485.98 829.58-2.38 2.86c-16.67 5.05-29.07 16.65-40.62 28.14-.46-.39-1.12-.56-1-1.45-.29-40.03-16.88-90.63-51.69-113.35-36.93-24.11-79.69-16.04-92.81 28.81-7.31 25-7.43 53.64-4.43 79.33-.17.76-2.27 1.4-3.07 1.67l-2.47-.81c-10.24-12.18-25.71-20.64-40.43-26.71l-1.1-2.48c1.13-1.08 2.83-1.62 3.03-3.49.42-3.84-3.31-19.58-3.91-25.13-3.72-34.05-7.2-70.2-8.12-104.38v-47c.31-9.84.8-20.46 3-30 .54 7.78 1.02 16.38 2.28 24.22 14.19 88.88 140.07 101.28 170.18 15.74 8.41-23.89 6.65-45.98 8.55-70.45 1.32-16.94 4.92-37.08 4.99-53.51l5.68 33.82c7.71 35.47 22.21 69.33 46.29 96.71-1.34 48.5 5.49 96.56 6.03 144.97l1.99 22.51Z"
				className="cls-5"
			/>
			<path
				d="M666.98 743.58c-11.26-14.62-16.82-25.8-9.76-44.26 11.12-29.1 43.17-30.41 62.75-50.74 1.32 9.93 1.95 21.23-.46 31.03-1.12 4.57-3.98 8.37-4.53 12.96 5.24.81 9.24-2.81 13.99-4 7.24 32.66-15.71 72.7-52.99 58l-.94-1.89c11.66-11.86 12.94-26.9-2.05-3.79-2 2.63-4 3.52-6.01 2.68ZM485.98 829.58c25.88-7.69 49.81-7.86 72.73 7.77 6.87 4.69 16.83 13.58 19.32 21.68 2.75 8.96-2.77 5.56-9.03 8.55-1.09-11.84-18.1-25.61-29.48-26.04-1.45-.05-4.03-.81-3.52 1.52 10.46 6.52 23.15 12.83 26.99 25.51l-21.85.85c-4.85-11.49-17.26-27.01-31.14-24.35 9.07 7.41 18.75 13.46 23.99 24.49-18.8.15-37.73-.93-56.38-3.11-4.6-.54-32.95-4.44-34.62-5.88-.44-2.43 2.47-4.89 3.96-6.52 10.41-11.42 24.36-20.12 39.04-24.48Z"
				className="cls-31"
			/>
			<path
				d="M666.98 743.58c.15-.38 4.82-4.02 5.97-5.53 2.1-2.77 6.95-12.2 10.34-11.37 8.31 2.05-4.33 16.98-7.31 19.9-8.82 8.63-16.71 19.85-27.09 27.41-36.5 26.6-80.01 20.85-118.29 1.47-10.54-5.34-40.67-25.15-43.57-36.43-2.27-8.84-2.6-25.93-2.11-35.08.08-1.57-1.09-2.8-.93-4.37 4.47 5.54 7.19 12.38 11.18 18.31 33.02 49.03 106.06 77.62 158.14 40.52 6.53-4.65 10.87-7.99 13.67-14.83Z"
				className="cls-6"
			/>
			<path
				d="M245.98 825.58c11.51 3.63 28.53 13.86 37.53 21.97 2.3 2.07 5.69 4.92 6.47 8.03-9.39 3.05-27.24 4.92-37.51 5.99-15.43 1.62-30.99 2.23-46.49 2 .59-4.22 16.97-18.19 16.98-19.49 0-.54-1.42-1.47-2.43-1.48-5.65-.08-21.32 15.89-22.6 21.99-.69.05-1.21-1.01-1.46-1.01h-21.5c4.55-12.6 17.06-19.79 25-29.99-9.27-.94-20.07 10.19-25.42 17.07-1.79 2.31-5.98 11.12-6.52 11.49-.59.4-7.17-1.13-8.09-2.04-4.69-4.64 7.36-17.85 11.01-21.05 20.47-17.95 49.47-21.55 75.01-13.49Z"
				style={{
					fill: '#fcfcfd',
				}}
			/>
			<path
				d="m243.81 571.4-26.82 7.17-6.93-57.37c21.68-9.99 42.19-22.25 61.92-35.62-9.16 28.66-20.75 56.63-28.16 85.82Z"
				className="cls-6"
			/>
			<path
				d="M27.74 528.84c4.76-.66 12.43-.26 15.13 4.37 6.11 10.49-19.89 13.6-22.43 18.36-1.52 2.85 1.2 4.95 4.04 5.09 6.35.33 25.04-7.37 26.47 3.5 1.52 11.51-22.5 5.87-23.88 14.06s20.58-2.05 24.17 5.59c5.92 12.59-21.83 15.19-30.97 9.97-10.88-6.21-14.75-31.3-13.2-42.62 1.35-9.9 11.25-17.02 20.67-18.32Z"
				className="cls-5"
			/>
			<path
				d="M686.74 562.84c11.72-1.79 23.63 3.16 25.8 15.68 2.57 14.82-2.66 41.25-19.74 45.37-7.74 1.87-30.12-.16-24.31-12.32 3.22-6.75 25.77 2.86 23.4-6.31-1.72-6.63-24.56-1.29-23.88-12.11.82-13.05 30.24-.25 31.98-6.11 2.13-7.19-20.09-8.5-22.5-12.46-3.7-6.09 3.88-10.93 9.27-11.75Z"
				style={{
					fill: '#a4b8c9',
				}}
			/>
			<path
				d="M171.73 330.84c36.86-4.81 42.71 44.28 8.76 44.81-29.18.45-41.23-40.57-8.76-44.81Z"
				className="cls-38"
			/>
			<path
				d="M263.98 527.58c-9.56 27.79-20.16 55.63-24 85-2.3-21.25 15.07-61.72 22.27-83.24.22-.66.77-4.27 1.73-1.76Z"
				style={{
					fill: '#0b1e54',
				}}
			/>
			<path
				d="M281.98 476.58c-1.91-.97-.65-3.37-.35-4.83 2.95-14.19 5.9-29.09.82-43.14l-6.47-4.03c2.63 1.2 6.62 1.02 8.5 4.04 4.45 16.2 1.45 31.97-2.5 47.96Z"
				style={{
					fill: '#112257',
				}}
			/>
			<path
				d="M485.98 298.58c1.66 1.04 1 3.8 1.02 5.49.31 25-.27 50.01-.01 75.01-1.42 1.62-.98-1.14-1.01-2-.07-2.16.01-4.34 0-6.5-.14-23.98.11-48.02 0-72Z"
				style={{
					fill: '#011650',
				}}
			/>
			<path
				d="M201.98 624.58c2.86-.97 5.37-1.57 7.55-3.95 8.1-8.84 0-36.03.45-48.05.04-1.11-.68-3.26.99-3-.52 12.93 7.47 38.55 1.21 49.69-1.49 2.65-6.83 7.78-10.2 5.3Z"
				style={{
					fill: '#0a1b53',
				}}
			/>
			<path
				d="M236.98 692.58c-.41-15.24-.47-31.77 0-47v47Z"
				style={{
					fill: '#d5e1e8',
				}}
			/>
			<path
				d="M423.98 500.58c-.3-10.69-1.27-27.95 0-38 1.66 1.04 1 3.79 1.02 5.49.11 8.99.09 18.04 0 27.03-.02 1.69.64 4.45-1.02 5.49Z"
				style={{
					fill: '#00063f',
				}}
			/>
			<path
				d="M414.04 405.54c-.33-.22-2.15-8.48-4.05-5.95-1.56 19.89-18.72 48.08-38.46 54.04-18.13 5.48-27.58-2.32-34.73-18.37-1.04-2.34-4.46-13.97-5.05-14.46-1.41-1.18-14.63-3.29-18.46-5.03-1.88-.86-9.65-5.44-5.02-7.45 2.39-1.04 18.98 4.86 24.18 5.3 22.52 1.9 48.49-4.6 66.49-18.58 3.21-2.49-4.37-.08-6.24-.64-2.57-.78-3.4-3.95-1.45-5.57 4.36-3.61 19.91-1.21 24.28 3.7 4.92 5.53 2.92 15.89-1.49 13.01Z"
				className="cls-33"
			/>
			<path
				d="m474.98 240.58-1.86-4.34c-6.42-68.44 15.05-135.58 57.55-189.07l3.31-1.6c5.3 6.92 8.08 18.18 9.7 26.8 12.05 63.76-17.83 129.99-68.7 168.2Z"
				className="cls-38"
			/>
			<path
				d="M310.98 222.58c-5.57-2.57-10.24-9.71-13.81-14.69-27.74-38.55-37.17-94.87-25.11-140.74 1.54-5.86 3.29-12.66 6.92-17.58.81.56 1.59 1.15 2.28 1.83s1.32 1.31 1.66 2.08c25.39 57.93 39.93 99.47 30.78 164-.12.88-.56 1.71-1.02 2.58s-1.07 1.71-1.7 2.51Z"
				style={{
					fill: '#fba97d',
				}}
			/>
			<path
				d="M533.98 45.58c-5.19 8.96-12.77 17.19-18.42 26.08-21.14 33.3-37.09 75.94-40.57 115.43-1.59 18.07.83 35.56-.01 53.49-.04.88.4 6.25-1.98 4s-4.81-23.1-5.06-27.45c-2.13-38.14 7.37-78.61 22.86-113.22 10.8-24.11 24.92-48.56 45.68-65.32 1.16 2.14-1.47 5.21-2.5 7Z"
				style={{
					fill: '#1f4271',
				}}
			/>
			<path
				d="M401.71 291.81c22.63-4.7 28.94 27.52 23.03 44.03-10.84 30.31-44.52 24.47-43.83-8.77.22-10.49 9.4-32.89 20.8-35.26Z"
				style={{
					fill: '#1d4170',
				}}
			/>
			<path
				d="M310.98 222.58c10.42-72.16-3.54-109.31-32-173-3.69-8.27-7.35-19.29 2.82-5.32 28.79 39.59 51.77 133.97 34.66 180.29-.58 1.57-5.02 9.96-5.98 10-3.52.15.28-10.48.5-11.98Z"
				className="cls-40"
			/>
			<path
				d="M314.77 291.8c14.29-1.4 19.98 16.57 19.19 28.27-.98 14.43-14.34 42.34-32.35 32.38-20.27-11.22-9.53-58.42 13.16-60.65Z"
				className="cls-8"
			/>
			<path
				d="M436.97 279.57c-1.48 1.39-13.35-8.22-15.95-9.54-3.99-2.02-10.07-4.3-14.52-4.5-3.22-.15-7.9 1.45-10.25.34-6.74-3.2 1.64-11.61 7.34-12.22 13.31-1.44 31.3 12.5 33.38 25.93ZM294.99 276.58c-1.54-13.08 29.77-33.52 36.23-18.75 4.66 10.65-8.76 6-15.29 7.2-7.46 1.38-15.1 7.01-20.94 11.55Z"
				className="cls-33"
			/>
			<path
				d="M503.98 541.58c2.16-6.17 10.61-10.79 17.01-10 .16-10.46-.8-20.76 1.46-31.04 7.43-33.79 48.44-46.7 75.01-24.94 17.28 14.15 18.77 35.11 16.52 55.98 6.1-.6 12.01 1.97 15.44 7.07 1.02 1.53 2.81 6.97 3.57 6.93.87 21.91.86 45.87 0 68-.47-.02-.79-.01-.98.51-.93 9.89-10.53 17.45-20.02 18.49-29.31.32-58.65.32-88 0-10.19-1.56-19.05-8.59-21-19-.24-24.02.09-48.02 1-72Z"
				className="cls-7"
			/>
			<path
				d="M611.98 632.58c-27.4 2.99-60.04-2.23-88 0h88Z"
				style={{
					fill: '#000a3d',
				}}
			/>
			<path
				d="M502.98 613.58c1.3-21.6-1.73-45.18-.04-66.55.15-1.87.42-3.69 1.04-5.45l-1 72Z"
				style={{
					fill: '#021145',
				}}
			/>
			<path
				d="M632.98 545.58c.12 0 1-1.7 1-.5v69c.01 1.19-.87-.49-1-.5v-68Z"
				style={{
					fill: '#a9f7fe',
				}}
			/>
			<path
				d="m63.24 526.82 101.25-12.23c5.47-.15 11.48-1.5 9.06 6.06-34.6 5.59-70.23 7.79-105.11 12.94-4.8.99-7.77-2.7-5.2-6.77Z"
				style={{
					fill: '#1e4270',
				}}
			/>
			<path
				d="M98.98 563.58c-9.01.25-18.07 1.02-27.17 2.31-12.92.44-3.85-7.96 4.47-6.87l16-.88-1.3-.56 55.98-6.55c3.44 2.62 2.62 6.42-1.7 7.33-15.46 1.45-30.86 3.57-46.28 5.22Z"
				className="cls-40"
			/>
			<path
				d="M64.98 477.58c-1.38 1.38 4.12 15.05-1.51 15.02-1.43.22-1.73-.75-2.3-1.71-3.04-5.1-1.65-22.36-4.24-28.87-1.27-5.69 7.35-6.4 11.59-6.47s7.65 1.47 9.35 5.63c3.69 9.08-4.11 12.5-3.77 14.71.21 1.34 10.71 14.84 3.35 14.73-3.58-.05-5.98-10.3-7.97-12.05-1.06-.93-3.96-1.54-4.5-.99Z"
				className="cls-33"
			/>
			<path
				d="M134.04 481.52c-.26-.21-.19-4.35-2.04-5.47-2.16-1.3-6.81-.07-9.43-.54-.11 8.29-7.46 14.4-6.47 2.69.77-9.01 4.57-19.46 5.34-28.71 1.94-4.43 4.41-2.47 6.3.84 1.65 2.89 10.8 25.53 11.09 27.99.38 3.35-3.48 4.27-4.78 3.19Z"
				className="cls-8"
			/>
			<path
				d="M51.63 461.93c7.75 7.93-.54 19.83-10.66 18.66 1.44 3.22 2.3 16.99-3.91 12.9-1.32-.87-4.52-29.7-3.96-31.28 1.18-3.37 15.14-3.75 18.53-.28Z"
				className="cls-7"
			/>
			<path
				d="M108.75 485.35c-.96 1.21-4.02 1.04-4.83-.47-1.44-5.73-13.36-25.47-12.99-29.79.08-.95.74-2.26 1.58-2.5 5.84-1.72 8.85 19.55 13.46 21.99.65-6.75.61-15.83 2.24-22.27 1.02-4.02 4.33-5.19 5.58-1.01.5 1.67-3.97 32.69-5.05 34.04ZM155.91 454.51c-2.68 1.76-4.06-1.15-6.37-.99-6.65.46-6.14 18.25-.86 19.88 3.82 1.18 4.63-.84 7.09-1.56 5.88-1.71 5.14 6.58-1.34 7.68-14.39 2.44-17.96-13.53-14.51-24.49 2.85-9.07 17.14-11.66 15.99-.51Z"
				className="cls-25"
			/>
			<path
				d="M173.88 478.47c-6.66 4.19-5.25-13.29-6.1-16.2-.65-2.24-15.61-15.19-7.18-16.63 2.03-.35 7.89 7.62 8.39 9.94 2.17 1.46 4.7-15.11 9.54-11.06 3.69 3.09-3.79 12.22-4.49 16.62-.57 3.53 1.58 16.25-.16 17.34Z"
				style={{
					fill: '#1d3f6f',
				}}
			/>
			<path
				d="M90.95 487.55c-1.88.16-4.15.46-4.81-1.64-.3-8.32-2.96-17.7-3.24-25.82s4.38-7.69 5.8.26c.6 3.38 3.39 26.45 2.24 27.21Z"
				style={{
					fill: '#1c3b6c',
				}}
			/>
			<path
				d="M90.98 557.58c1.11.05 3.26-.69 2.99.99-7.33 1.1-18.48.32-25.29 2.22-1.64.46-3.94 2.91-1.74 4.32s22.19-2.13 26.55-2.53c1.62-.15 4.48-.59 5.48 1-5.04.54-30.77 4.11-33.05 2.55s-.81-5.38 1.78-6.32c3.63-1.31 18.95-2.44 23.26-2.24Z"
				style={{
					fill: '#07164d',
				}}
			/>
			<path
				d="M393.97 422.58c-6.28 14.98-26.67 34.57-43 21.47 9.48-12.82 27.01-21.58 43-21.47Z"
				className="cls-38"
			/>
			<path
				d="M421.97 313.58c-17.99-10.95-27.99 14.43-22.29 28.8 2.02 5.1 4.71 4.94 8.3 8.18-15.35 5.76-23.08-9.44-23.09-22.49 0-25.36 26.87-50.04 37.08-14.5Z"
				className="cls-43"
			/>
			<path
				d="M411.98 324.58c-1.2-1.21.15-9.97 5.05-6.56 3.99 2.78-2.89 8.74-5.05 6.56Z"
				style={{
					fill: '#f5f7f9',
				}}
			/>
			<path
				d="M323.64 298.91c1.54 1.5 6.41 11.25 5.33 12.66-19.78-14.79-31.91 25.06-18.96 33.46 1.46.95 7.82 1.58 5.96 3.52-.23.24-3.66.94-4.48 1.01-20.78 1.85-18.58-27.97-11.9-40.89 4.19-8.1 15.31-18.26 24.05-9.78Z"
				className="cls-43"
			/>
			<path
				d="M321.58 315.67c5.5-1.79 4.87 4.87 1.8 5.81-3.83 1.17-4.72-4.86-1.8-5.81Z"
				style={{
					fill: '#eff2f4',
				}}
			/>
			<path
				d="M594.98 531.58h-55c-2.03-21.29-.08-48.06 27.5-48.06s29.67 27.3 27.5 48.06Z"
				className="cls-22"
			/>
			<path
				d="M560.98 609.58v-25.5c0-.89-7.46-5.13-8.05-11.95-1.92-22.28 30.77-21.49 30.09-1.08-.26 7.57-6.91 9.22-7.83 13.24-1.12 4.9 1.01 21.98-.65 24.35-1.4 2.01-10.72.46-13.56.94Z"
				style={{
					fill: '#86cbf0',
				}}
			/>
			<path
				d="M64.1 471.46c-1.09-.69-.89-7.22-2.13-8.87 18.3-5.94 9.69 13.66 2.13 8.87Z"
				style={{
					fill: '#fafbfb',
				}}
			/>
			<path
				d="M128.98 469.57h-6l2.01-9.99 3.51 6.98.48 3.01z"
				style={{
					fill: '#f6f8f9',
				}}
			/>
			<path
				d="M39.98 474.58c.53-5.84-4.12-10.44 4.45-9.97s4.9 12.94-4.45 9.97Z"
				style={{
					fill: '#f9fafb',
				}}
			/>
		</g>
	</svg>
);
